<template>
    <div class="fake-portfolio-card">
        <div class="fake-portfolio-card__image">
            <slot />
        </div>
        <div class="fake-portfolio-card__line" />
    </div>
</template>

<style lang="scss" scoped>
    .fake-portfolio-card {
        width: 100%;

        &__image {
            aspect-ratio: 16 / 9;
            border-radius: var(--joy-core-radius-3);
            background: var(--joy-color-neutral-20);
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__line {
            margin-top: var(--joy-core-spacing-2);
            height: 12px;
            width: 60%;
            border-radius: var(--joy-core-radius-2);
            background: var(--joy-color-neutral-20);
        }
    }
</style>
